(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iceyard-jewel-viewer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('iceyard-jewel-viewer')) {
    customElements.define('iceyard-jewel-viewer', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.items = [...this.querySelectorAll('[data-jewel-showcase]')];
        this.near = false;
        this.modelStates = new Map();
        this.index = 0;
        if (!this.items.length) return;
        this.querySelector('[data-jewel-navigation]')?.removeAttribute('hidden');
        this.querySelector('[data-jewel-previous]')?.addEventListener('click', () => this.show(this.index - 1), { signal });
        this.querySelector('[data-jewel-next]')?.addEventListener('click', () => this.show(this.index + 1), { signal });
        this.querySelectorAll('[data-jewel-illustration]').forEach(root => this.prepareIllustration(root, signal));
        document.addEventListener('shopify:block:select', event => {
          const index = this.items.findIndex(item => item.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.show(index);
        }, { signal });
        this.observer?.disconnect();
        this.observer = new IntersectionObserver(entries => {
          this.near = entries[0].isIntersecting;
          if (this.near) this.activateModel(this.items[this.index]);
          else this.items.forEach(item => this.deactivateModel(item));
        }, { rootMargin: '400px 0px' });
        this.observer.observe(this);
        this.show(0);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.items?.forEach(item => this.deactivateModel(item));
      }

      deactivateModel(item) {
        const root = item.querySelector('[data-jewel-free-model]');
        if (!root) return;
        this.modelStates?.get(root)?.controller.abort();
        root.jewelTrackballController?.abort();
        const model = root.querySelector('[data-jewel-model-slot] model-viewer');
        model?.removeAttribute('src');
        root.querySelector('[data-jewel-model-slot]')?.replaceChildren();
        root.querySelector('[data-jewel-trackball]')?.setAttribute('hidden', '');
        const surface = root.querySelector('[data-jewel-trackball]');
        if (surface) delete surface.dataset.dragging;
        root.querySelector('[data-jewel-model-controls]')?.setAttribute('hidden', '');
        const retry = root.querySelector('[data-jewel-retry]');
        if (retry) { retry.onclick = null; retry.hidden = true; }
        this.modelStates?.delete(root);
      }

      show(index) {
        this.index = (index + this.items.length) % this.items.length;
        this.items.forEach((item, itemIndex) => {
          item.hidden = itemIndex !== this.index;
          if (item.hidden) this.deactivateModel(item);
        });
        const counter = this.querySelector('[data-jewel-index]');
        if (counter) counter.textContent = String(this.index + 1);
        if (this.near) this.activateModel(this.items[this.index]);
      }

      static loadModelRuntime() {
        if (customElements.get('model-viewer')) return Promise.resolve();
        if (!this.modelRuntime) {
          this.modelRuntime = new Promise((resolve, reject) => {
            if (!window.Shopify?.loadFeatures) { reject(new Error('Model runtime unavailable')); return; }
            const timeout = setTimeout(() => reject(new Error('Model runtime timeout')), 20000);
            window.Shopify.loadFeatures([{ name: 'model-viewer', version: '1.12', onLoad: error => {
              if (error) { clearTimeout(timeout); reject(error); return; }
              customElements.whenDefined('model-viewer').then(() => { clearTimeout(timeout); resolve(); });
            } }]);
          }).catch(error => { this.modelRuntime = null; throw error; });
        }
        return this.modelRuntime;
      }

      async activateModel(item) {
        const root = item?.querySelector('[data-jewel-free-model]');
        if (!root || this.modelStates.has(root)) return;
        const template = root.querySelector('[data-jewel-model-template]');
        const slot = root.querySelector('[data-jewel-model-slot]');
        const status = root.querySelector('[data-jewel-model-status]');
        const retry = root.querySelector('[data-jewel-retry]');
        if (!template || !slot || !status) return;
        const controller = new AbortController();
        this.controller.signal.addEventListener('abort', () => controller.abort(), { once: true });
        const signal = controller.signal;
        const state = { started: true, controller };
        this.modelStates.set(root, state);
        status.hidden = false;
        status.textContent = this.dataset.loadingLabel;
        if (retry) retry.hidden = true;
        const fail = () => {
          if (signal.aborted || this.modelStates.get(root) !== state) return;
          root.querySelector('[data-jewel-trackball]').hidden = true;
          root.querySelector('[data-jewel-model-controls]').hidden = true;
          status.textContent = this.dataset.errorLabel;
          status.hidden = false;
          if (retry) {
            retry.hidden = false;
            retry.onclick = () => { this.deactivateModel(item); this.activateModel(item); };
          }
        };
        try {
          await this.constructor.loadModelRuntime();
          if (signal.aborted || this.modelStates.get(root) !== state) return;
          if (item.hidden || !this.near) { this.deactivateModel(item); return; }
          const model = template.content.firstElementChild.cloneNode(true);
          const source = model.dataset.modelSrc || model.getAttribute('src');
          model.removeAttribute('src');
          model.removeAttribute('camera-controls');
          model.removeAttribute('auto-rotate');
          model.removeAttribute('ar');
          model.setAttribute('reveal', 'auto');
          model.setAttribute('interaction-prompt', 'none');
          model.setAttribute('camera-orbit', '0deg 90deg 115%');
          model.setAttribute('camera-target', '0m 0m 0m');
          model.setAttribute('orientation', `0deg ${Number(root.dataset.startPitch) || 0}deg ${Number(root.dataset.startYaw) || 0}deg`);
          model.setAttribute('shadow-intensity', '0');
          model.setAttribute('environment-image', 'neutral');
          model.setAttribute('interpolation-decay', '0');
          model.setAttribute('loading', 'eager');
          model.addEventListener('error', fail, { signal });
          model.addEventListener('load', () => {
            if (signal.aborted || this.modelStates.get(root) !== state) return;
            if (typeof model.orientation !== 'string') { fail(); return; }
            status.hidden = true;
            root.querySelector('.iy-jewel__poster')?.setAttribute('hidden', '');
            this.prepareTrackball(root, model, signal);
          }, { once: true, signal });
          slot.replaceChildren(model);
          model.setAttribute('src', source);
        } catch {
          fail();
        }
      }

      prepareTrackball(root, model, signal) {
        const surface = root.querySelector('[data-jewel-trackball]');
        const controls = root.querySelector('[data-jewel-model-controls]');
        if (!surface || !controls) return;
        root.jewelTrackballController?.abort();
        const trackballController = new AbortController();
        root.jewelTrackballController = trackballController;
        signal.addEventListener('abort', () => trackballController.abort(), { once: true });
        signal = trackballController.signal;
        surface.hidden = false;
        controls.hidden = false;
        const pointers = new Map();
        const yaw = (Number(root.dataset.startYaw) || 0) * Math.PI / 180;
        const pitch = (Number(root.dataset.startPitch) || 0) * Math.PI / 180;
        const initialQuaternion = [Math.sin(pitch / 2) * Math.cos(yaw / 2), Math.cos(pitch / 2) * Math.sin(yaw / 2), -Math.sin(pitch / 2) * Math.sin(yaw / 2), Math.cos(pitch / 2) * Math.cos(yaw / 2)];
        let quaternion = [...initialQuaternion];
        let radius = 115;
        let drag = null;
        let pinch = null;
        const normalize = q => {
          const length = Math.hypot(...q) || 1;
          return q.map(value => value / length);
        };
        const multiply = (a, b) => normalize([
          a[3] * b[0] + a[0] * b[3] + a[1] * b[2] - a[2] * b[1],
          a[3] * b[1] - a[0] * b[2] + a[1] * b[3] + a[2] * b[0],
          a[3] * b[2] + a[0] * b[1] - a[1] * b[0] + a[2] * b[3],
          a[3] * b[3] - a[0] * b[0] - a[1] * b[1] - a[2] * b[2]
        ]);
        const render = () => {
          const [x, y, z, w] = quaternion;
          const m11 = 1 - 2 * (y * y + z * z);
          const m13 = 2 * (x * z + y * w);
          const m21 = 2 * (x * y + z * w);
          const m22 = 1 - 2 * (x * x + z * z);
          const m23 = 2 * (y * z - x * w);
          const m31 = 2 * (x * z - y * w);
          const m33 = 1 - 2 * (x * x + y * y);
          const pitch = Math.asin(-Math.max(-1, Math.min(1, m23)));
          const yaw = Math.abs(m23) < .9999999 ? Math.atan2(m13, m33) : Math.atan2(-m31, m11);
          const roll = Math.abs(m23) < .9999999 ? Math.atan2(m21, m22) : 0;
          model.setAttribute('orientation', `${roll}rad ${pitch}rad ${yaw}rad`);
          model.setAttribute('camera-orbit', `0deg 90deg ${radius}%`);
        };
        const vector = point => {
          const rect = surface.getBoundingClientRect();
          const size = Math.max(Math.min(rect.width, rect.height), 1);
          let x = (2 * (point.x - rect.left) - rect.width) / size;
          let y = (rect.height - 2 * (point.y - rect.top)) / size;
          const length = x * x + y * y;
          if (length > 1) { const scale = Math.sqrt(length); x /= scale; y /= scale; return [x, y, 0]; }
          return [x, y, Math.sqrt(1 - length)];
        };
        const between = (a, b) => {
          const dot = Math.max(-1, Math.min(1, a[0] * b[0] + a[1] * b[1] + a[2] * b[2]));
          if (dot < -.999999) {
            return normalize(Math.abs(a[0]) < .9 ? [0, a[2], -a[1], 0] : [-a[2], 0, a[0], 0]);
          }
          return normalize([a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0], 1 + dot]);
        };
        const zoom = value => { radius = Math.max(65, Math.min(220, value)); render(); };
        const restartGesture = () => {
          const values = [...pointers.values()];
          drag = values.length === 1 ? { vector: vector(values[0]), quaternion: [...quaternion] } : null;
          pinch = values.length === 2 ? { distance: Math.max(Math.hypot(values[0].x - values[1].x, values[0].y - values[1].y), 1), radius } : null;
          if (values.length) surface.dataset.dragging = 'true'; else delete surface.dataset.dragging;
        };
        surface.addEventListener('pointerdown', event => {
          if (event.button !== 0 || pointers.size >= 2) return;
          pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
          surface.setPointerCapture(event.pointerId);
          restartGesture();
        }, { signal });
        surface.addEventListener('pointermove', event => {
          if (!pointers.has(event.pointerId)) return;
          pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
          if (pointers.size === 2 && pinch) {
            const [a, b] = [...pointers.values()];
            const distance = Math.max(Math.hypot(a.x - b.x, a.y - b.y), 1);
            zoom(pinch.radius * pinch.distance / distance);
          } else if (drag) {
            quaternion = multiply(between(drag.vector, vector(pointers.get(event.pointerId))), drag.quaternion);
            render();
          }
        }, { signal });
        const end = event => {
          if (!pointers.has(event.pointerId)) return;
          pointers.delete(event.pointerId);
          if (surface.hasPointerCapture(event.pointerId)) surface.releasePointerCapture(event.pointerId);
          restartGesture();
        };
        surface.addEventListener('pointerup', end, { signal });
        surface.addEventListener('pointercancel', end, { signal });
        surface.addEventListener('lostpointercapture', end, { signal });
        surface.addEventListener('keydown', event => {
          const step = Math.PI / (event.shiftKey ? 4 : 18);
          let axis;
          let angle = step;
          if (event.key === 'ArrowLeft') { axis = [0, 1, 0]; angle = -step; }
          else if (event.key === 'ArrowRight') axis = [0, 1, 0];
          else if (event.key === 'ArrowUp') { axis = [1, 0, 0]; angle = -step; }
          else if (event.key === 'ArrowDown') axis = [1, 0, 0];
          else if (event.key.toLowerCase() === 'q') { axis = [0, 0, 1]; angle = -step; }
          else if (event.key.toLowerCase() === 'e') axis = [0, 0, 1];
          else if (event.key === '+' || event.key === '=') zoom(radius - 10);
          else if (event.key === '-') zoom(radius + 10);
          else if (event.key === 'Home') { quaternion = [...initialQuaternion]; radius = 115; render(); }
          else return;
          if (axis) {
            const sine = Math.sin(angle / 2);
            quaternion = multiply([axis[0] * sine, axis[1] * sine, axis[2] * sine, Math.cos(angle / 2)], quaternion);
            render();
          }
          event.preventDefault();
        }, { signal });
        root.querySelector('[data-jewel-zoom-in]').addEventListener('click', () => zoom(radius - 15), { signal });
        root.querySelector('[data-jewel-zoom-out]').addEventListener('click', () => zoom(radius + 15), { signal });
        root.querySelector('[data-jewel-reset]').addEventListener('click', () => { quaternion = [...initialQuaternion]; radius = 115; render(); }, { signal });
        render();
      }

      prepareIllustration(root, signal) {
        const stage = root.querySelector('[data-jewel-drag]');
        const group = root.querySelector('[data-jewel-chain]');
        const slider = root.querySelector('[data-jewel-angle]');
        const output = root.querySelector('[data-jewel-degrees]');
        if (!stage || !group || !slider || !output) return;
        let angle = Number(slider.value) || 25;
        let pointer = null;
        const draw = value => {
          angle = ((value % 360) + 360) % 360;
          const radians = angle * Math.PI / 180;
          const links = [];
          for (let index = 0; index < 32; index++) {
            const theta = index * Math.PI * 2 / 32;
            const x = Math.cos(theta) * 155;
            const z = Math.sin(theta) * 110;
            links.push({ x: 250 + x * Math.cos(radians) + z * Math.sin(radians) * .85, y: 220 + Math.sin(theta) * 48, z: -x * Math.sin(radians) + z * Math.cos(radians), rotation: index * 11.25 + angle });
          }
          links.sort((left, right) => left.z - right.z);
          group.replaceChildren(...links.map(link => {
            const ellipse = document.createElementNS('http://www.w3.org/2000/svg', 'ellipse');
            const attributes = { cx: link.x, cy: link.y, rx: 23, ry: 13, transform: `rotate(${link.rotation} ${link.x} ${link.y})`, opacity: .58 + (link.z + 170) / 600 };
            Object.entries(attributes).forEach(([key, value]) => ellipse.setAttribute(key, String(value)));
            return ellipse;
          }));
          const rounded = Math.round(angle) % 360;
          slider.value = String(rounded);
          output.textContent = `${rounded}°`;
        };
        const endDrag = event => {
          if (!pointer || event.pointerId !== pointer.id) return;
          if (stage.hasPointerCapture(pointer.id)) stage.releasePointerCapture(pointer.id);
          pointer = null;
          delete stage.dataset.dragging;
        };
        stage.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, angle, active: false };
          stage.setPointerCapture(event.pointerId);
        }, { signal });
        stage.addEventListener('pointermove', event => {
          if (!pointer || event.pointerId !== pointer.id) return;
          const deltaX = event.clientX - pointer.x;
          const deltaY = event.clientY - pointer.y;
          if (!pointer.active) {
            if (Math.abs(deltaX) < 5 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
            pointer.active = true;
            stage.dataset.dragging = 'true';
          }
          draw(pointer.angle + deltaX / Math.max(stage.clientWidth, 1) * 360);
        }, { signal });
        stage.addEventListener('pointerup', endDrag, { signal });
        stage.addEventListener('pointercancel', endDrag, { signal });
        stage.addEventListener('lostpointercapture', event => {
          if (pointer?.id === event.pointerId) { pointer = null; delete stage.dataset.dragging; }
        }, { signal });
        stage.addEventListener('keydown', event => {
          const step = event.shiftKey ? 45 : 10;
          if (event.key === 'ArrowLeft') draw(angle - step);
          else if (event.key === 'ArrowRight') draw(angle + step);
          else if (event.key === 'Home') draw(0);
          else if (event.key === 'End') draw(359);
          else return;
          event.preventDefault();
        }, { signal });
        slider.addEventListener('input', () => draw(Number(slider.value)), { signal });
        root.querySelector('[data-jewel-rotation]')?.removeAttribute('hidden');
        draw(angle);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iceyard-ref-custom-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('iceyard-custom-gallery')) {
    customElements.define('iceyard-custom-gallery', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('[data-iy-custom-track]');
        this.cards = [...this.querySelectorAll('[data-iy-custom-card]')];
        this.openers = [...this.querySelectorAll('[data-iy-custom-open]')];
        this.previous = this.querySelector('[data-iy-custom-previous]');
        this.next = this.querySelector('[data-iy-custom-next]');
        this.counter = this.querySelector('[data-iy-custom-count]');
        this.dialog = this.querySelector('[data-iy-custom-dialog]');
        this.activeIndex = 0;
        if (!this.track || !this.cards.length) return;
        this.querySelector('[data-iy-custom-controls]').hidden = false;
        this.track.addEventListener('scroll', () => this.scheduleUpdate(), { passive: true, signal });
        this.addEventListener('click', event => {
          const opener = event.target.closest('[data-iy-custom-open]');
          if (opener && this.dialog?.showModal) {
            event.preventDefault();
            this.openImage(opener);
          } else if (event.target.closest('[data-iy-custom-previous]')) {
            this.move(-1);
          } else if (event.target.closest('[data-iy-custom-next]')) {
            this.move(1);
          } else if (event.target.closest('[data-iy-custom-dialog-previous]')) {
            this.moveImage(-1);
          } else if (event.target.closest('[data-iy-custom-dialog-next]')) {
            this.moveImage(1);
          } else if (event.target.closest('[data-iy-custom-zoom]')) {
            const zoomed = this.querySelector('[data-iy-custom-dialog-image]').classList.toggle('is-zoomed');
            this.querySelector('[data-iy-custom-zoom]').setAttribute('aria-pressed', String(zoomed));
          } else if (event.target.closest('[data-iy-custom-close]') || event.target === this.dialog) {
            this.dialog.close();
          }
        }, { signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          let index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(event.key === 'ArrowRight' ? 1 : -1);
            return;
          }
          else if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = this.cards.length - 1;
          else return;
          event.preventDefault();
          this.scrollToCard(index);
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const index = this.cards.findIndex(card => card.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.scrollToCard(index, false);
        }, { signal });
        this.dialog.addEventListener('close', () => this.releaseDialog(), { signal });
        this.dialog.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.moveImage(event.key === 'ArrowRight' ? 1 : -1);
        }, { signal });
        this.resizeObserver?.disconnect();
        this.resizeObserver = new ResizeObserver(() => this.scheduleUpdate());
        this.resizeObserver.observe(this.track);
        this.scheduleUpdate();
      }

      scheduleUpdate() {
        if (this.updateFrame) return;
        this.updateFrame = requestAnimationFrame(() => {
          this.updateFrame = null;
          this.updateControls();
        });
      }

      updateControls() {
        const bounds = this.track.getBoundingClientRect();
        const first = this.cards[0].offsetLeft;
        let nearest = 0;
        let distance = Infinity;
        const visible = [];
        this.cards.forEach((card, index) => {
          const difference = Math.abs(card.offsetLeft - first - this.track.scrollLeft);
          if (difference < distance) { distance = difference; nearest = index; }
          const rect = card.getBoundingClientRect();
          const intersection = Math.min(rect.right, bounds.right) - Math.max(rect.left, bounds.left);
          if (intersection >= rect.width * .5) visible.push(index + 1);
        });
        this.activeIndex = nearest;
        const allVisible = this.track.scrollWidth - this.track.clientWidth <= 2;
        this.previous.disabled = allVisible;
        this.next.disabled = allVisible;
        const start = visible[0] || nearest + 1;
        const end = visible[visible.length - 1] || start;
        const text = String(start).padStart(2, '0') + (end > start ? '–' + String(end).padStart(2, '0') : '');
        if (this.counter.textContent !== text) this.counter.textContent = text;
      }

      move(direction) {
        this.updateControls();
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (max <= 2) return;
        if (direction > 0 && this.track.scrollLeft >= max - 3) this.scrollToCard(0, false);
        else if (direction < 0 && this.track.scrollLeft <= 3) this.scrollToCard(this.cards.length - 1, false);
        else this.scrollToCard(this.activeIndex + direction);
      }

      moveImage(direction) {
        if (this.openers.length < 2) return;
        const index = this.openers.indexOf(this.currentImage);
        this.openImage(this.openers[(index + direction + this.openers.length) % this.openers.length]);
      }

      scrollToCard(index, animate = true) {
        const target = this.cards[Math.max(0, Math.min(index, this.cards.length - 1))];
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: target.offsetLeft - this.cards[0].offsetLeft, behavior: animate && !reduced ? 'smooth' : 'instant' });
      }

      openImage(opener) {
        if (!this.dialog.open) this.opener = opener;
        this.currentImage = opener;
        const imageBox = this.querySelector('[data-iy-custom-dialog-image]');
        imageBox.classList.remove('is-zoomed');
        imageBox.scrollTo(0, 0);
        this.querySelector('[data-iy-custom-zoom]').setAttribute('aria-pressed', 'false');
        this.querySelector('[data-iy-custom-dialog-count]').textContent = `${this.openers.indexOf(opener) + 1} / ${this.openers.length}`;
        this.querySelector('[data-iy-custom-dialog-nav]').hidden = this.openers.length < 2;
        const category = this.querySelector('[data-iy-custom-dialog-category]');
        category.textContent = opener.dataset.category || '';
        category.hidden = !opener.dataset.category;
        const photo = new Image();
        photo.alt = opener.dataset.imageAlt;
        photo.width = Number(opener.dataset.imageWidth);
        photo.height = Number(opener.dataset.imageHeight);
        photo.decoding = 'async';
        photo.src = opener.dataset.imageUrl;
        this.querySelector('[data-iy-custom-dialog-image]').replaceChildren(photo);
        this.querySelector('[data-iy-custom-dialog-title]').textContent = opener.dataset.title;
        const caption = this.querySelector('[data-iy-custom-dialog-caption]');
        caption.textContent = opener.dataset.caption;
        caption.hidden = !opener.dataset.caption;
        const link = this.querySelector('[data-iy-custom-dialog-link]');
        link.hidden = !opener.dataset.designUrl;
        if (opener.dataset.designUrl) link.setAttribute('href', opener.dataset.designUrl);
        else link.removeAttribute('href');
        if (!this.dialog.open) {
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          this.dialog.showModal();
          this.querySelector('[data-iy-custom-close]').focus({ preventScroll: true });
        }
      }

      releaseDialog() {
        if (this.previousOverflow !== undefined) {
          document.documentElement.style.overflow = this.previousOverflow;
          this.previousOverflow = undefined;
        }
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        this.opener = null;
        this.querySelector('[data-iy-custom-dialog-image]')?.replaceChildren();
      }

      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.releaseDialog();
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.updateFrame);
        this.updateFrame = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iceyard-ref-custom-page"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('iceyard-custom-form')) {
  customElements.define('iceyard-custom-form', class extends HTMLElement {
    connectedCallback() {
      this.timeout = window.setTimeout(() => this.start(), 0);
    }
    disconnectedCallback() {
      window.clearTimeout(this.timeout);
      window.clearTimeout(this.errorTimer);
      window.clearInterval(this.checkTimer);
      this.observer?.disconnect();
    }
    start() {
      this.status = this.querySelector('[data-form-status]');
      this.notes = this.querySelector('[data-form-notes]');
      this.root = this.querySelector('[data-form-root]');
      if (!this.status || !this.root) return;
      this.status.hidden = false;
      this.querySelector('[data-form-retry]').addEventListener('click', () => window.location.reload());
      this.observer = new MutationObserver(() => this.check());
      this.observer.observe(this.root, { childList: true, subtree: true });
      this.checkTimer = window.setInterval(() => this.check(), 1000);
      this.errorTimer = window.setTimeout(() => {
        if (!this.ready) {
          this.querySelector('[data-form-loading]').hidden = true;
          this.querySelector('[data-form-unavailable]').hidden = false;
        }
      }, 12000);
      this.check();
    }
    hasFields(root) {
      if (root.querySelector('input:not([type="hidden"]), textarea, select')) return true;
      return Array.from(root.querySelectorAll('*')).some(element => element.shadowRoot && this.hasFields(element.shadowRoot));
    }
    check() {
      if (this.ready || !this.isConnected) return;
      if (this.hasFields(this.root) || (this.root.shadowRoot && this.hasFields(this.root.shadowRoot))) {
        this.ready = true;
        this.status.hidden = true;
        this.notes.hidden = false;
        window.clearTimeout(this.errorTimer);
        window.clearInterval(this.checkTimer);
        this.observer.disconnect();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iceyard-ref-custom"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('iceyard-custom-background')) {
  customElements.define('iceyard-custom-background', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.near = false;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.addEventListener('playing', () => this.classList.add('is-playing'), options);
      this.video.addEventListener('error', () => this.classList.remove('is-playing'), options);
      this.sync = () => {
        const restricted = this.motion.matches || navigator.connection?.saveData;
        if (restricted || document.hidden) {
          this.video.pause();
          if (restricted) this.classList.remove('is-playing');
          return;
        }
        if (this.near && !this.video.getAttribute('src')) {
          this.video.src = this.video.dataset.videoUrl;
          this.video.preload = 'metadata';
          this.video.load();
        }
        if (this.visible) this.video.play().catch(() => {});
        else this.video.pause();
      };
      this.motion.addEventListener('change', this.sync, options);
      document.addEventListener('visibilitychange', this.sync, options);
      if ('IntersectionObserver' in window) {
        this.preloader = new IntersectionObserver(entries => {
          this.near = entries[0].isIntersecting;
          this.sync();
        }, { rootMargin: '180px' });
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0.01 });
        this.preloader.observe(this);
        this.observer.observe(this);
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.preloader?.disconnect();
      this.controller?.abort();
      this.video?.pause();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iceyard-ref-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('iceyard-gallery')) {
    customElements.define('iceyard-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.window = this.querySelector('[data-gallery-window]');
        this.track = this.querySelector('[data-gallery-track]');
        this.original = this.querySelector('[data-gallery-original]');
        this.button = this.querySelector('[data-gallery-toggle]');
        this.dialog = this.querySelector('[data-gallery-dialog]');
        if (!this.window || !this.original?.children.length) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.manual = this.reduced.matches;
        this.hovered = false;
        this.continuous = this.dataset.continuous === 'true';
        if (!this.continuous) {
        this.querySelector('[data-gallery-controls]').hidden = false;
        this.button.addEventListener('click', () => this.setManual(!this.manual), options);
        this.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', () => this.step(Number(button.dataset.galleryStep)), options));
        this.window.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = true;
          this.syncPlayback();
        }, options);
        this.window.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.syncPlayback();
        }, options);
        this.window.addEventListener('pointerdown', event => {
          const cloneLink = this.cloneLinkAt(event.clientX, event.clientY);
          this.pointerStart = { x: event.clientX, y: event.clientY, link: cloneLink };
          if (event.pointerType === 'touch' || event.pointerType === 'pen') this.setManual(true);
        }, options);
        this.window.addEventListener('pointercancel', () => { this.pointerStart = null; }, options);
        this.window.addEventListener('focusin', () => this.setManual(true), options);
        this.window.addEventListener('keydown', event => {
          if (event.target !== this.window || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') {
            this.setManual(true);
            this.window.scrollTo({ left: event.key === 'Home' ? 0 : this.window.scrollWidth, behavior: this.reduced.matches ? 'instant' : 'smooth' });
          } else this.step(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        this.window.addEventListener('click', event => {
          if (event.isTrusted && event.detail && this.pointerStart?.link) {
            const start = this.pointerStart;
            this.pointerStart = null;
            event.preventDefault();
            if (Math.hypot(event.clientX - start.x, event.clientY - start.y) <= 8) start.link.click();
            return;
          }
          const directLink = event.target.closest('[data-gallery-link]');
          if (directLink) {
            if (!directLink.hasAttribute('data-gallery-zoom')) return;
            event.preventDefault();
            this.openImage(directLink);
            return;
          }
          if (!event.isTrusted || !event.detail) return;
          if (this.pointerStart && Math.hypot(event.clientX - this.pointerStart.x, event.clientY - this.pointerStart.y) > 8) return;
          this.cloneLinkAt(event.clientX, event.clientY)?.click();
        }, options);
        this.querySelector('[data-gallery-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => this.lastImageLink?.focus({ preventScroll: true }), options);
        } else {
          this.intersectionObserver = new IntersectionObserver(entries => {
            this.offscreen = !entries[0].isIntersecting;
            this.syncPlayback();
          });
          this.intersectionObserver.observe(this);
        }
        this.reduced.addEventListener('change', () => {
          this.manual = this.reduced.matches;
          this.build();
        }, options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        document.addEventListener('shopify:block:select', event => {
          if (this.continuous) return;
          const card = event.target.closest('[data-gallery-block]');
          if (!card || !this.original.contains(card)) return;
          this.setManual(true);
          this.window.scrollTo({ left: card.offsetLeft - this.original.offsetLeft, behavior: 'instant' });
        }, options);
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => this.build());
        });
        this.resizeObserver.observe(this.window);
        this.resizeObserver.observe(this.original);
        this.build();
        document.fonts?.ready.then(() => { if (this.isConnected) this.build(); });
      }

      position() {
        if (!this.animation || !this.duration) return this.window.scrollLeft;
        return ((Number(this.animation.currentTime) || 0) % this.duration) / this.duration * this.distance;
      }

      setManual(manual) {
        if (this.continuous) return;
        if (this.reduced.matches) manual = true;
        if (this.manual === manual) return;
        const position = this.position();
        this.manual = manual;
        this.build(position);
      }

      step(direction) {
        this.setManual(true);
        const width = this.original.children[0].getBoundingClientRect().width;
        const gap = parseFloat(getComputedStyle(this.original).columnGap) || 0;
        this.window.scrollBy({ left: direction * (width + gap), behavior: this.reduced.matches ? 'instant' : 'smooth' });
      }

      cloneLinkAt(x, y) {
        const card = [...this.track.querySelectorAll('[data-gallery-clone] [data-gallery-card]')].find(item => {
          const rect = item.getBoundingClientRect();
          return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
        });
        return card ? this.original.querySelector('[data-gallery-card="' + card.dataset.galleryCard + '"] [data-gallery-link]') : null;
      }

      openImage(link) {
        this.setManual(true);
        this.lastImageLink = link;
        const image = this.dialog.querySelector('[data-gallery-dialog-image]');
        image.src = link.href;
        image.alt = link.dataset.galleryAlt || '';
        this.dialog.querySelector('[data-gallery-dialog-caption]').textContent = link.dataset.galleryCaption || image.alt;
        this.dialog.showModal();
      }

      build(position = this.position()) {
        this.animation?.cancel();
        this.animation = null;
        this.track.querySelectorAll('[data-gallery-clone]').forEach(clone => clone.remove());
        this.distance = this.original.getBoundingClientRect().width;
        const viewport = this.window.clientWidth;
        if (this.continuous) {
          if (this.reduced.matches) this.window.setAttribute('tabindex', '0');
          else this.window.removeAttribute('tabindex');
        }
        if (this.button) {
        this.button.hidden = this.reduced.matches || !this.distance;
        this.button.textContent = this.manual ? this.button.dataset.resumeLabel : this.button.dataset.pauseLabel;
        this.button.setAttribute('aria-pressed', String(this.manual));
        }
        this.dataset.running = String(!this.manual);
        if (!this.distance || !viewport || this.reduced.matches) {
          this.window.scrollLeft = position;
          return;
        }
        const copies = Math.ceil(viewport / this.distance) + 1;
        for (let index = 0; index < copies; index++) {
          const clone = this.original.cloneNode(true);
          clone.removeAttribute('data-gallery-original');
          clone.setAttribute('data-gallery-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.inert = true;
          clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
          clone.querySelectorAll('[data-shopify-editor-block]').forEach(node => node.removeAttribute('data-shopify-editor-block'));
          clone.querySelectorAll('a,button,[tabindex]').forEach(node => node.setAttribute('tabindex', '-1'));
          this.track.appendChild(clone);
        }
        if (this.manual) {
          this.window.scrollLeft = position;
          return;
        }
        this.window.scrollLeft = 0;
        this.duration = this.distance / Math.max(15, Math.min(60, Number(this.dataset.speed) || 25)) * 1000;
        this.animation = this.track.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(' + -this.distance + 'px)' }], { duration: this.duration, iterations: Infinity, easing: 'linear' });
        this.animation.currentTime = ((position % this.distance) / this.distance) * this.duration;
        this.syncPlayback();
      }

      syncPlayback() {
        if (!this.animation) return;
        if (this.hovered || document.hidden || this.dialog?.open || (this.continuous && this.offscreen)) this.animation.pause();
        else this.animation.play();
      }

      disconnectedCallback() {
        this.animation?.cancel();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        cancelAnimationFrame(this.resizeFrame);
        this.dialog?.close();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iceyard-ref-motion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('iceyard-product-viewer')) {
    customElements.define('iceyard-product-viewer', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.panels = [...this.querySelectorAll('[data-iy-product-panel]')];
        this.thumbnails = [...this.querySelectorAll('[data-iy-product-thumbnail]')];
        this.counter = this.querySelector('[data-iy-product-count]');
        this.currentIndex = 0;
        if (this.panels.length < 2) return;
        this.querySelectorAll('[data-iy-product-controls]').forEach(control => { control.hidden = false; });
        this.addEventListener('click', event => {
          const thumbnail = event.target.closest('[data-iy-product-thumbnail]');
          if (thumbnail) this.showMedia(this.thumbnails.indexOf(thumbnail));
          else if (event.target.closest('[data-iy-product-next]')) this.showMedia(this.currentIndex + 1);
          else if (event.target.closest('[data-iy-product-previous]')) this.showMedia(this.currentIndex - 1);
        }, { signal: this.controller.signal });
        this.addEventListener('keydown', event => {
          const thumbnail = event.target.closest('[data-iy-product-thumbnail]');
          if (!thumbnail) return;
          const index = this.thumbnails.indexOf(thumbnail);
          let target;
          if (event.key === 'ArrowRight') target = index + 1;
          else if (event.key === 'ArrowLeft') target = index - 1;
          else if (event.key === 'Home') target = 0;
          else if (event.key === 'End') target = this.panels.length - 1;
          else return;
          event.preventDefault();
          this.showMedia(target);
          this.thumbnails[this.currentIndex].focus({ preventScroll: true });
        }, { signal: this.controller.signal });
      }

      showMedia(index) {
        this.currentIndex = (index + this.panels.length) % this.panels.length;
        this.panels.forEach((panel, panelIndex) => {
          panel.hidden = panelIndex !== this.currentIndex;
          if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());
        });
        this.thumbnails.forEach((thumbnail, thumbnailIndex) => {
          thumbnail.setAttribute('aria-pressed', String(thumbnailIndex === this.currentIndex));
        });
        if (this.counter) this.counter.textContent = this.currentIndex + 1;
        const thumbnail = this.thumbnails[this.currentIndex];
        const strip = thumbnail?.parentElement;
        if (thumbnail && strip) {
          const left = thumbnail.getBoundingClientRect().left - strip.getBoundingClientRect().left + strip.scrollLeft;
          if (left < strip.scrollLeft) strip.scrollLeft = left;
          else if (left + thumbnail.offsetWidth > strip.scrollLeft + strip.clientWidth) {
            strip.scrollLeft = left + thumbnail.offsetWidth - strip.clientWidth;
          }
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.querySelectorAll('video').forEach(video => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iceyard-ref-shoppable"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('iceyard-shoppable')){
class IceyardShoppable extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;this.abort=new AbortController();const options={signal:this.abort.signal};
    this.viewport=this.querySelector('.iy-shop__viewport');this.track=this.querySelector('.iy-shop__track');this.cards=Array.from(this.track.children);this.total=this.cards.length;this.index=0;
    this.dialog=this.querySelector('dialog');this.pauseButton=this.querySelector('[data-pause]');this.counter=this.querySelector('[data-count]');this.stage=this.querySelector('.iy-shop__stage');this.claws=Array.from(this.querySelectorAll('[data-claw]'));
    this.motion=matchMedia('(prefers-reduced-motion:reduce)');this.paused=this.dataset.autoplay!=='true'||this.motion.matches;this.inView=false;this.position=0;this.lastTime=0;
    if(!this.total)return;
    if(this.total>1){for(const side of ['before','after']){const group=document.createDocumentFragment();for(const card of this.cards){const clone=card.cloneNode(true);clone.dataset.clone='true';clone.setAttribute('aria-hidden','true');clone.removeAttribute('data-shopify-editor-block');for(const element of clone.querySelectorAll('a,button,[tabindex]'))element.setAttribute('tabindex','-1');group.append(clone)}if(side==='before')this.track.prepend(group);else this.track.append(group)}}
    this.displayCards=Array.from(this.track.children);this.viewport.classList.add('iy-shop__ready');this.setAttribute('data-ready','');this.querySelector('.iy-shop__controls').hidden=this.total<2;
    this.resize=new ResizeObserver(()=>this.measure());this.resize.observe(this.viewport);this.measure();
    this.observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;this.schedule()},{threshold:.01});this.observer.observe(this.viewport);
    this.viewport.addEventListener('scroll',()=>{if(this.running||this.moving)return;clearTimeout(this.settle);this.paint();this.settle=setTimeout(()=>this.normalize(),140)},options);
    this.viewport.addEventListener('pointerdown',()=>this.setPaused(true),options);
    this.viewport.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.move(event.key==='ArrowRight'?1:-1)}},options);
    this.addEventListener('focusin',event=>{this.focused=event.target!==this.pauseButton;this.schedule()},options);
    this.addEventListener('focusout',()=>queueMicrotask(()=>{this.focused=this.contains(document.activeElement)&&document.activeElement!==this.pauseButton;this.schedule()}),options);
    this.querySelector('[data-prev]').addEventListener('click',()=>this.move(-1),options);
    this.querySelector('[data-next]').addEventListener('click',()=>this.move(1),options);
    this.pauseButton.addEventListener('click',()=>this.setPaused(!this.paused),options);
    this.addEventListener('click',event=>{const opener=event.target.closest('[data-open]');if(opener&&this.contains(opener)){event.preventDefault();this.open(opener.dataset.open,opener)}},options);
    this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close(),options);
    this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close()}},options);
    this.dialog.addEventListener('close',()=>{document.documentElement.style.overflow=this.oldOverflow||'';if(this.opener?.isConnected)this.opener.focus({preventScroll:true});this.schedule()},options);
    this.dialog.addEventListener('keydown',event=>{if(event.key!=='Tab')return;const focusable=Array.from(this.dialog.querySelectorAll('a[href],button:not([disabled])')).filter(n=>n.getClientRects().length);const first=focusable[0],last=focusable[focusable.length-1];if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus()}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus()}},options);
    this.motion.addEventListener('change',()=>{if(this.motion.matches)this.setPaused(true);this.paint()},options);
    document.addEventListener('visibilitychange',()=>this.schedule(),options);this.update();this.schedule();
  }
  measure(){if(!this.total)return;const oldStep=this.step,oldPosition=this.viewport.scrollLeft;const gap=parseFloat(getComputedStyle(this.track).columnGap)||0;this.cardWidth=parseFloat(getComputedStyle(this.cards[0]).width);this.step=this.cardWidth+gap;this.viewWidth=this.viewport.clientWidth;this.lift=parseFloat(getComputedStyle(this.stage).getPropertyValue('--iy-lift'))||30;if(!this.step)return;this.position=oldStep?oldPosition/oldStep*this.step:(this.total>1?this.total:0)*this.step;this.viewport.scrollLeft=this.position;this.paint()}
  normalize(){if(this.total<2||!this.step)return;const span=this.total*this.step;let left=this.viewport.scrollLeft;while(left<span)left+=span;while(left>=span*2)left-=span;this.position=left;this.viewport.scrollLeft=left;this.paint()}
  paint(){if(!this.step)return;const left=this.viewport.scrollLeft,w=this.viewWidth,cw=this.cardWidth;const edge=cw*.52;let out=null,enter=null;for(let i=0;i<this.displayCards.length;i++){const card=this.displayCards[i],center=i*this.step-left+cw/2;let lift=0,turn=0;if(!this.motion.matches){if(center<edge&&center>-cw/2){lift=Math.max(0,Math.min(1,(edge-center)/(edge+cw/2)));turn=-lift*4;out={x:center,y:-lift*this.lift,open:Math.max(0,1-lift*4)}}else if(center>w-edge&&center<w+cw/2){lift=Math.max(0,Math.min(1,(center-w+edge)/(edge+cw/2)));turn=lift*4;enter={x:center,y:-lift*this.lift,open:Math.max(0,1-lift*4)}}}card.style.setProperty('--iy-y',(-lift*this.lift).toFixed(2)+'px');card.style.setProperty('--iy-turn',turn.toFixed(2)+'deg')}
    [out,enter].forEach((point,i)=>{const claw=this.claws[i];claw.style.opacity=point&&!this.motion.matches?'1':'0';if(point){claw.style.setProperty('--iy-x',(point.x-36).toFixed(2)+'px');claw.style.setProperty('--iy-y',point.y.toFixed(2)+'px');claw.style.setProperty('--iy-open',point.open.toFixed(2))}});this.stage.style.setProperty('--iy-belt',(-left%23).toFixed(2)+'px');this.index=((Math.floor((left+.5)/this.step)-this.total)%this.total+this.total)%this.total;this.counter.textContent=(this.index+1)+' / '+this.total;
  }
  move(delta){if(this.total<2||!this.step)return;this.setPaused(true);clearTimeout(this.settle);this.normalize();const from=this.viewport.scrollLeft,to=(Math.round(from/this.step)+delta)*this.step;if(this.motion.matches){this.viewport.scrollLeft=to;this.normalize();return}this.moving=true;let start;const slide=time=>{if(!this.moving)return;if(start===undefined)start=time;const progress=Math.min(1,(time-start)/340);this.viewport.scrollLeft=from+(to-from)*(1-Math.pow(1-progress,3));this.paint();if(progress<1)this.manualFrame=requestAnimationFrame(slide);else{this.moving=false;this.normalize()}};this.manualFrame=requestAnimationFrame(slide)}
  stopManual(){cancelAnimationFrame(this.manualFrame);this.moving=false}
  setPaused(value){this.stopManual();this.paused=value;this.update();this.schedule()}
  update(){this.counter.textContent=(this.index+1)+' / '+this.total;this.pauseButton.textContent=this.paused?this.pauseButton.dataset.playLabel:this.pauseButton.dataset.pauseLabel;this.pauseButton.setAttribute('aria-pressed',String(this.paused));this.pauseButton.disabled=this.motion.matches}
  schedule(){cancelAnimationFrame(this.animation);this.running=false;this.lastTime=0;const run=!this.paused&&!this.focused&&this.inView&&!document.hidden&&!this.dialog.open&&this.total>1&&!this.motion.matches;if(!run)return;clearTimeout(this.settle);this.position=this.viewport.scrollLeft;this.running=true;this.animation=requestAnimationFrame(time=>this.tick(time))}
  tick(time){if(!this.running)return;const dt=this.lastTime?Math.min(time-this.lastTime,64):0;this.lastTime=time;this.position+=dt*(this.viewWidth<750?25:36)/1000;const span=this.total*this.step;if(this.position>=span*2)this.position-=span;if(this.position<span)this.position+=span;this.viewport.scrollLeft=this.position;this.paint();this.animation=requestAnimationFrame(next=>this.tick(next))}
  open(index,opener){const template=this.querySelector('template[data-look="'+index+'"]');if(!template||!this.dialog.showModal)return;this.setPaused(true);this.opener=opener;this.querySelector('.iy-shop__dialog-body').replaceChildren(template.content.cloneNode(true));this.oldOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';this.dialog.showModal();this.querySelector('[data-close]').focus()}
  disconnectedCallback(){this.stopManual();this.abort?.abort();this.resize?.disconnect();this.observer?.disconnect();clearTimeout(this.settle);cancelAnimationFrame(this.animation);this.running=false;if(this.dialog?.open){this.dialog.close();document.documentElement.style.overflow=this.oldOverflow||''}this.querySelectorAll('[data-clone]').forEach(n=>n.remove());this.ready=false}
}
customElements.define('iceyard-shoppable',IceyardShoppable);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iceyard-video-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('iceyard-video-stories')) {
    customElements.define('iceyard-video-stories', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.rail = this.querySelector('[data-story-rail]');
        this.dialog = this.querySelector('[data-story-dialog]');
        this.content = this.querySelector('[data-story-content]');
        this.status = this.querySelector('[data-story-status]');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.videos = [...this.querySelectorAll('[data-kind="video"]')].map(card => ({ card, video: card.querySelector('video'), visible: false }));
        this.videos.forEach(item => {
          item.video.controls = false;
          item.video.muted = true;
          item.video.defaultMuted = true;
          item.video.setAttribute('aria-hidden', 'true');
          item.video.tabIndex = -1;
          item.card.querySelector('[data-open-video]').hidden = false;
          item.card.querySelector('[data-open-video]').addEventListener('click', event => this.openVideo(item, event.currentTarget), options);
        });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              const item = this.videos.find(candidate => candidate.card === entry.target);
              if (item) item.visible = entry.isIntersecting && entry.intersectionRatio >= .5;
            });
            this.syncAutoplay();
          }, { threshold: [0, .5] });
          this.videos.forEach(item => this.observer.observe(item.card));
        }
        this.querySelectorAll('[data-open-image]').forEach(link => link.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || typeof this.dialog.showModal !== 'function') return;
          event.preventDefault();
          this.prepareDialog(link, false);
          const image = document.createElement('img');
          image.src = link.href;
          image.alt = link.closest('[data-story-card]').querySelector('img')?.alt || '';
          this.content.append(image);
        }, options));
        this.querySelectorAll('[data-open-instagram]').forEach(link => link.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          const url = this.instagramURL(link.href);
          if (!url || typeof this.dialog.showModal !== 'function') return;
          event.preventDefault();
          this.openInstagram(url, link);
        }, options));
        this.querySelector('[data-story-navigation]').hidden = false;
        this.querySelectorAll('[data-story-step]').forEach(button => button.addEventListener('click', () => this.step(Number(button.dataset.storyStep)), options));
        this.rail.addEventListener('keydown', event => {
          if (event.target !== this.rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.step(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        this.querySelector('[data-story-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, options);
        this.dialog.addEventListener('close', () => this.closeMedia(), options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) { this.pauseAll(); this.content.querySelector('video')?.pause(); }
          else this.syncAutoplay();
        }, options);
        this.reduced.addEventListener('change', () => { this.pauseAll(); this.syncAutoplay(); }, options);
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('[data-story-card]');
          card?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
        }, options);
      }
      instagramURL(value) {
        try {
          const url = new URL(value);
          if (url.protocol !== 'https:' || !['instagram.com', 'www.instagram.com'].includes(url.hostname) || url.username || url.password || url.port) return null;
          const match = url.pathname.match(/^\/(p|reel)\/([A-Za-z0-9_-]{5,64})\/?$/);
          return match ? 'https://www.instagram.com/' + match[1] + '/' + match[2] + '/' : null;
        } catch { return null; }
      }
      step(direction) {
        const card = this.rail.querySelector('[data-story-card]');
        this.rail.scrollBy({ left: direction * ((card?.offsetWidth || 320) + parseFloat(getComputedStyle(this.rail).gap || 18)), behavior: this.reduced.matches ? 'instant' : 'smooth' });
      }
      play(video) {
        const playing = video.play();
        if (playing?.catch) playing.catch(() => {});
      }
      pauseAll() {
        this.videos?.forEach(item => item.video.pause());
      }
      syncAutoplay() {
        const allowed = !document.hidden && !this.dialog.open && !this.reduced.matches && !navigator.connection?.saveData && this.dataset.autoplay === 'true';
        let playing = 0;
        this.videos.forEach(item => {
          if (allowed && item.visible && playing < 2) {
            playing++;
            item.video.muted = true;
            this.play(item.video);
          } else {
            item.video.pause();
          }
        });
      }
      prepareDialog(trigger, instagram) {
        this.pauseAll();
        this.trigger = trigger;
        this.content.replaceChildren();
        this.status.textContent = '';
        this.querySelector('[data-instagram-notice]').hidden = !instagram;
        const fallback = this.querySelector('[data-instagram-fallback]');
        fallback.hidden = !instagram;
        fallback.removeAttribute('href');
        this.dialog.showModal();
      }
      openVideo(item, trigger) {
        if (typeof this.dialog.showModal !== 'function') {
          const source = item.video.currentSrc || item.video.querySelector('source')?.src;
          if (source) window.location.assign(source);
          return;
        }
        this.prepareDialog(trigger, false);
        const video = item.video.cloneNode(true);
        video.removeAttribute('id');
        video.controls = true;
        video.removeAttribute('aria-hidden');
        video.removeAttribute('tabindex');
        video.loop = false;
        video.muted = false;
        video.defaultMuted = false;
        video.removeAttribute('muted');
        video.preload = 'metadata';
        this.content.append(video);
        this.play(video);
      }
      async openInstagram(url, trigger) {
        this.prepareDialog(trigger, true);
        this.querySelector('[data-instagram-fallback]').href = url;
        this.status.textContent = this.dataset.loadingLabel;
        const post = document.createElement('blockquote');
        post.className = 'instagram-media';
        post.dataset.instgrmPermalink = url;
        post.dataset.instgrmVersion = '14';
        const link = document.createElement('a');
        link.href = url;
        link.textContent = this.dataset.instagramLabel;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        post.append(link);
        this.content.append(post);
        const token = Symbol();
        this.embedToken = token;
        try {
          await this.loadInstagram();
          if (!this.isConnected || !this.dialog.open || this.embedToken !== token) return;
          window.instgrm.Embeds.process();
          this.status.textContent = this.dataset.unavailableLabel;
        } catch {
          if (this.embedToken === token) this.status.textContent = this.dataset.unavailableLabel;
        }
      }
      loadInstagram() {
        if (window.instgrm?.Embeds) return Promise.resolve();
        if (!window.iceyardInstagramEmbedPromise) {
          window.iceyardInstagramEmbedPromise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://www.instagram.com/embed.js';
            script.async = true;
            const timer = setTimeout(() => reject(new Error('Instagram unavailable')), 15000);
            script.onload = () => { clearTimeout(timer); window.instgrm?.Embeds ? resolve() : reject(new Error('Instagram unavailable')); };
            script.onerror = () => { clearTimeout(timer); reject(new Error('Instagram unavailable')); };
            document.head.append(script);
          }).catch(error => { window.iceyardInstagramEmbedPromise = null; throw error; });
        }
        return window.iceyardInstagramEmbedPromise;
      }
      closeMedia() {
        this.embedToken = null;
        this.content.querySelector('video')?.pause();
        this.content.replaceChildren();
        this.status.textContent = '';
        this.trigger?.focus({ preventScroll: true });
        this.syncAutoplay();
      }
      disconnectedCallback() {
        this.pauseAll();
        this.content?.querySelector('video')?.pause();
        this.embedToken = null;
        this.observer?.disconnect();
        this.controller?.abort();
        this.dialog?.close();
        this.content?.replaceChildren();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  customElements.whenDefined('newsletter-popup').then(() => {
    if (customElements.get('iceyard-newsletter-popup')) return;
    const PrestigeNewsletterPopup = customElements.get('newsletter-popup');
    class IceyardNewsletterPopup extends PrestigeNewsletterPopup {
      connectedCallback() {
        if (this.dataset.subscribed === 'true') {
          try { localStorage.setItem('theme:popup-filled', 'true'); } catch (error) {}
        }
        super.connectedCallback();
        clearTimeout(this.iceyardPopupTimer);
        if (this.canAppearAutomatically) {
          this.iceyardPopupTimer = setTimeout(() => this.tryOpenWhenIdle(), this.apparitionDelay);
        }
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.open) {
            event.preventDefault();
            this.hide();
          }
        }, { signal: this.abortController.signal });
      }
      disconnectedCallback() {
        clearTimeout(this.iceyardPopupTimer);
        super.disconnectedCallback();
      }
      get shouldAppearAutomatically() {
        return false;
      }
      get canAppearAutomatically() {
        if (window.Shopify?.designMode || this.open) return false;
        try {
          if (localStorage.getItem('theme:popup-filled') === 'true') return false;
          if (this.hasAttribute('only-once') && localStorage.getItem('theme:popup-appeared') === 'true') return false;
          const lastShown = Number(localStorage.getItem('iceyard:newsletter:last-shown') || 0);
          const days = Number(this.dataset.repeatDays || 7);
          return Date.now() - lastShown >= days * 86400000;
        } catch (error) { return false; }
      }
      tryOpenWhenIdle() {
        if (!this.isConnected || !this.canAppearAutomatically) return;
        const focusedField = document.activeElement?.matches('input, textarea, select, [contenteditable="true"], [contenteditable=""]');
        const anotherDialog = Array.from(document.querySelectorAll('dialog[open], [role="dialog"][open]')).some(dialog => dialog !== this);
        if (document.hidden || focusedField || anotherDialog) {
          this.iceyardPopupTimer = setTimeout(() => this.tryOpenWhenIdle(), 1000);
          return;
        }
        this.show();
      }
      attributeChangedCallback(name, oldValue, newValue) {
        super.attributeChangedCallback(name, oldValue, newValue);
        if (name === 'open' && newValue !== null && !window.Shopify?.designMode) {
          try { localStorage.setItem('iceyard:newsletter:last-shown', String(Date.now())); } catch (error) {}
        }
      }
    }
    customElements.define('iceyard-newsletter-popup', IceyardNewsletterPopup);
  });

  } catch(e) { console.error(e); }
})();
})();
